import { CordataWorkTriple } from "@libry-content/integrations";
import { Work } from "@biblioteksentralen/cordata";
import { getWorks } from "../searchApi/searchWorks";
import { SiteSearchConfig } from "../searchApi/searchConfig";
import { ResolvedSite } from "@libry-content/common";

export const getWorksAssociatedWithAggregateManifestations = async (
  workTriples: CordataWorkTriple[],
  searchConfig: SiteSearchConfig
): Promise<Record<string, Work[]>> => {
  if (workTriples.length === 0) return {};
  const aggregateTriples = workTriples
    .filter(({ isAggregateManifestation }) => isAggregateManifestation)
    .map((workTriple) => ({
      id: workTriple.manifestationId,
      workIds: workTriple.relatedExpressions?.map(({ workId }) => workId) ?? [],
    }));

  const workIds = aggregateTriples.flatMap(({ workIds }) => workIds);

  if (!workIds || workIds.length === 0) return {};

  try {
    const works = await getWorks(searchConfig, workIds);
    if (works.length === 0) throw new Error("No works retrieved when getting aggregate manifestations related works");
    const aggregateManifestationObject: Record<string, Work[]> = aggregateTriples.reduce(
      (resultObject, manifestationIdAndWorkIds) => ({
        ...resultObject,
        [manifestationIdAndWorkIds.id]: manifestationIdAndWorkIds.workIds
          .map((workId) => works.find((work) => workId === work.id))
          .filter((work) => !!work),
      }),
      {}
    );

    return aggregateManifestationObject;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const getAggregateManifestationWorksCacheKey = (
  workTriples: CordataWorkTriple[],
  site: ResolvedSite | undefined
) =>
  site
    ? `/site/${site?._id}/aggregateManifestationWorks/manifestations/${workTriples
        .map(({ manifestationId }) => manifestationId)
        .join(",")}`
    : null;
